export default __webpack_public_path__ + "static/media/interns.590fd105.jpg";